import { notEqual } from '@cims-online/shared'
import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../IFITrackerContext/types'
import { Space, Typography } from 'antd'
import { HelpMessage } from 'utils/constants'
import MultiLineSpace from 'components/MultiLineSpace'

export function useIssueDescription(): CIMSSingleColumn<IdentifiedFieldIssue> {
  const width = 400
  return {
    title: 'Description',
    render: ({ reportDescription, initialDescription }) => {
      const style = { maxWidth: width }
      if (
        reportDescription &&
        initialDescription &&
        notEqual(reportDescription, initialDescription)
      )
        return (
          <Space size="small" direction="vertical" style={style}>
            <Typography.Text strong>Initial Issue Description</Typography.Text>
            <MultiLineSpace text={initialDescription} />
            <Typography.Text strong>Current Issue Description</Typography.Text>
            <MultiLineSpace text={reportDescription} />
          </Space>
        )
      return (
        <MultiLineSpace style={style}>
          {reportDescription ?? initialDescription}
        </MultiLineSpace>
      )
    },
    help: HelpMessage.IdentifiedFieldIssues.IFITracker.IssueDescription,
    width,
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { reportDescription, initialDescription }) => {
        const lower = value.toString().toLowerCase()
        return (
          !!reportDescription?.toLowerCase()?.includes(lower) ||
          !!initialDescription?.toLowerCase()?.includes(lower)
        )
      },
    },
  }
}
